import { spacing, color } from '@upstox/upstox-ui';

export const infoIcon: CSSFunction = () => ({
  width: '13px !important',
  height: '13px !important',
  cursor: 'pointer',
});

export const cardWidth: CSSFunction = ({ theme }) => ({
  width: '100%',
  marginBottom: spacing(theme, ['medium']),
  '@media (min-width:576px)': {
    marginRight: `${spacing(theme, ['medium'])}!important`,
  },
  '@media (min-width:768px)': {
    // marginBottom: spacing(theme, ['none']),
    width: '432px',
  },

  '@media (min-width:1400px)': {
    marginRight: `${spacing(theme, ['xlarge'])}!important`,
    marginBottom: spacing(theme, ['none']),
  },
});

export const cardStyles: CSSFunction = ({ theme }) => ({
  backgroundColor: color(theme, 'ui1'),
  borderRadius: '8px',
  width: '100%',
});

export const listItem: CSSFunction = ({ theme }) => ({
  height: '68px',
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const titleWrapper: CSSFunction = ({ theme }) => ({
  marginBottom: spacing(theme, ['xsmall']),
});
export const registrarTitle: CSSFunction = ({ theme }) => ({
  marginRight: spacing(theme, [10]),
});

export const labelBlock: CSSFunction = () => ({
  '@media (max-width:576px)': {
    // marginBottom: spacing(theme, ['none']),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    minWidth: '50%',
  },
});
export const valueBlock: CSSFunction = () => ({
  '@media (max-width:576px)': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    textAlign: 'right',
    minWidth: '50%',
  },
});

export const cardWrapper: CSSFunction = ({ theme }) => ({
  width: '100%',
  padding: spacing(theme, ['xlarge', 'xlarge', 0, 'xlarge']),
});

export const line1: CSSFunction = ({ theme }) => ({
  border: '1px solid rgba(0, 0, 0, 0.25)',
});
